import React, { useRef } from "react";
import styles from "../../../src/views/OtpVerify/Styles.module.css";
// import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../src/assets/CRMAssets/login_logo@2x.png";
import { IconButton, ButtonBase, Typography, Input, Button, CircularProgress } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../../src/components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import useOtpVerifyHook from "../../../src/views/OtpVerify/OtpVerify.hook";
import { ArrowPrimaryButton } from "../../components/Buttons/PrimaryButton";
import PhoneNo from "../../views/LoginDietitian/Component/Phone";
import historyUtils from "../../../src/libs/history.utils";
import SnackbarUtils from "../../libs/SnackbarUtils";
import DashboardSnackbar from "../../../src/components/Snackbar.component";


function OtpVerifyView() {
    const theme = useTheme();
    const { domainTheme } = useSelector((state) => state.app_setting);
    const cachedTheme = React.useMemo(() => {
        if (domainTheme) return domainTheme;
        try {
            const cached = localStorage.getItem("domainTheme");
            return cached ? JSON.parse(cached) : null;
        } catch (e) {
            return null;
        }
    }, [domainTheme]);

    const activeTheme = domainTheme || cachedTheme;
    const renderLogo = activeTheme?.theme?.display_logo || activeTheme?.theme?.logo || logoImage;
    const renderBg = activeTheme?.theme?.background_image || activeTheme?.theme?.background_logo;

    const {
        handleSubmit,
        otp,
        inputRefs,
        handleKeyPress,
        isValid,
        // handleResendOtp,
        disableResend,
        timerCounter,
        handleVerifyOtp,
        errorOtp,
        snackbar,
        setSnackbar,
       submitting,
        handleChnageContact,
        contact
    } = useOtpVerifyHook();

    return (
        <div className={"login"} id="loginview" style={renderBg ? { backgroundImage: `url(${renderBg})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}>
            <div className={styles.overlay} style={renderBg ? { backgroundImage: `url(${renderBg})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}></div>
            <div className={styles.mainLoginView}></div>
            <div className={styles.container}>
                <div className={styles.loginFlex2}>
                    <div className={styles.logoImageData}>
                        <img
                            crossOrigin="anonymous"
                            src={renderLogo}
                            alt="text_data"
                            style={{ width: "250px" }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = logoImage;
                            }}
                        />
                    </div>
                    <div className={styles.signContainer}>
                        <div className={styles.loginHeaderText}>
                            <Typography variant="h3">OTP Verification</Typography>

                            <Typography
                                variant={"body1"}
                                sx={{ color: theme?.palette?.text?.secondary }}
                            >
                                You would have got a 8 digit code on <span>{contact ? contact : "+91 9872346788"}</span>
                                <Typography
                                    component="span"
                                    sx={{
                                        color: theme.palette.primary.main,
                                        cursor: "pointer",
                                        ml: 1,
                                        textDecoration: "underline",
                                    }}
                                    onClick={() => handleChnageContact("/login")}
                                >
                                    Change Number
                                </Typography>
                            </Typography>
                        </div>

                        <div className={styles.formContainer}>
                            <div className={styles.formFlexGrouup}>
                                <div className={"formGroup"}>
                                    {Array.from({ length: 8 }).map((_, index) => (
                                        <Input
                                            key={index}
                                            className={styles.inputFields}
                                            type="text"
                                            name={`${index}`}
                                            inputRef={(el) => (inputRefs.current[index] = el)}
                                            value={otp[index] || ""}
                                            inputProps={{ maxLength: 1 }}
                                            onChange={(e) => handleKeyPress(e, index)}
                                            onKeyDown={(e) => handleKeyPress(e, index)}
                                        />

                                    ))}

                                </div>

                            </div>
                        </div>

                        <div className={styles.loginAction}>
                            <Button
                                variant={"h6"}
                                onClick={() => handleSubmit()}
                            >
                                {submitting ? (
                                    <CircularProgress size={24} color={"primary"} />
                                ) : (
                                    "VERIFY"
                                )}
                            </Button>
                        </div>

                    </div>
                </div>

            </div>
            <DashboardSnackbar />
        </div>
    );
}

export default OtpVerifyView;
